

































































    import { Component, Vue, Watch ,Prop} from 'vue-property-decorator';
    import 'swiper/dist/css/swiper.css'
    import $ from 'jquery';
    @Component(
        {
            components:{
            }
        }
    )
    export default class productmeal extends Vue {
        public $refs!: {
            mySwiper:HTMLFormElement
        };
        activeid = 1
        swiperOption={
            // some swiper options/callbacks
            // 所有的参数同 swiper 官方 api 参数
            // ...
            //循环
            loop:true,
            //每张播放时长3秒，自动播放
            autoplay:{
                delay:5000,
                disableOnInteraction: false,
            },
        
        }
        // ##########################################
        async mounted () {
        
        }
        // 选中变样式
        chooseactive(type){
            this.activeid = type
            this.$nextTick(()=>{
                this.$refs.mySwiper.swiper.slideTo(type, 1000, false);
                $('#tab_bar').css('transform',`translateX(${(type-1)*320}px)`)
            })
        }
        slideChange(){
            this.activeid = this.$refs.mySwiper.swiper.activeIndex==3?1:this.$refs.mySwiper.swiper.activeIndex;
            console.log('this.activeName',this.activeid);
            if(this.activeid==0){
                $('#tab_bar').css('transform',`translateX(${(2-1)*320}px)`)
                return
            }
            $('#tab_bar').css('transform',`translateX(${(this.activeid-1)*320}px)`)
        }
        
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/home/components/productmeal.vue